module.exports = __webpack_public_path__ + "static/hifi7-7c2e3f1473a3f90332726250087ec2f0.jpg";